export const getPriceString = (price, people) => {
    let string = '';
    string = price + ' CHF';
    if (people === 1) {
        string = string + ' / persona'
    } else if (people !== 0 && people !== 1) {
        string = string + ' / ' + people + ' persone'
    }
    return string
}